import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar";
import EditPage from "./components/EditPage";
import MyEdits from "./components/MyEdits";
import Login from "./components/Login";
import PDFUpload from "./components/PDFUpload";
import TranslatePage from "./components/TranslatePage";
import TranscreatePages from "./components/TranscreatePages";
import "./styles/main.css";
import { useNavigate } from "react-router-dom";

function App() {
  const [user, setUser] = useState<any>(null);
  //const navigate = useNavigate();
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Error parsing user", e);
      }
    }
  }, []);

  const handleLogin = (newUser: any) => {
    setUser(newUser); // Update the user state
    localStorage.setItem("user", JSON.stringify(newUser));
    localStorage.setItem("userId", newUser.userId);
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("userId");
    // navigate("/");
  };

  return (
    <Router>
      {user && <NavBar onLogout={handleLogout} />}
      <Routes>
        <Route path="/" element={<Login onLogin={handleLogin} />} />
        <Route path="/my-edits" element={<MyEdits />} />
        <Route path="/edit" element={<PDFUpload />} />
        <Route path="/translate" element={<TranslatePage />} />
        <Route path="/transcreate" element={<TranscreatePages />} />
      </Routes>
    </Router>
  );
}

export default App;
